import { Stack, Typography, useTheme } from "@mui/material";
import { type FC, useState } from "react";
import { ACTIVITY_NOTE_PREVIEW_LIMIT } from "web_myplann/Activities/constants";
import { ExpandToggleButton } from "web_myplann/Shared/Components/ExpandToggleButton";

type Props = {
	title: string;
	content: string;
};

export const ActivityNoteBlock: FC<Props> = ({ title, content }) => {
	const theme = useTheme();
	const [expanded, setExpanded] = useState(false);

	const isLong = content.length > ACTIVITY_NOTE_PREVIEW_LIMIT;
	const preview = isLong
		? `${content.slice(0, ACTIVITY_NOTE_PREVIEW_LIMIT)}...`
		: content;

	return (
		<Stack>
			<Typography variant="bodyStrong" mb={0.4}>
				{title}
			</Typography>
			<Typography
				variant="body1"
				color={theme.palette.grey[600]}
				lineHeight={1.625}
			>
				{expanded ? content : preview}
			</Typography>
			{isLong && (
				<ExpandToggleButton
					isExpanded={expanded}
					onClick={() => setExpanded((value) => !value)}
					fontSize={12}
				/>
			)}
		</Stack>
	);
};
